import { FC, ReactNode } from 'react'
import { CopyButton } from './CopyButton'
import { cn } from '@/lib/utils'

interface Props {
  content: string
  children?: ReactNode
  className?: string
  onCopy?: () => void
}

export const CopyableContent: FC<Props> = ({ content, children = content, className, onCopy }) => {
  return (
    <div className="flex items-center gap-2">
      <div className={cn('truncate', className)}>{children}</div>
      <CopyButton text={content} onCopy={onCopy} />
    </div>
  )
}
